import React from 'react';

import Preloader from '../components/Miscellaneous/Preloader';
import Header from '../components/Header/Header';
import Breadcrumb from '../components/Breadcrumb/BreadcrumbFive';
import BlogSectionA from '../components/Blog/BlogSectionThree';
import Footer from '../components/Footer/Footer';
import SearchModal from '../components/Miscellaneous/SearchModal';
import OffcanvasMenu from '../components/Miscellaneous/OffcanvasMenu';
import MagicCursor from '../components/Miscellaneous/MagicCursor';
import LenisScroll from '../components/Header/LenisScroll';

const BlogA = () => {
    return (
        <div>
            <MagicCursor />
            <Preloader />
            <LenisScroll />
            <div className="main">
                <Header />
                <div id="main-wrapper" className="main-wrapper">
                    <Breadcrumb />
                    <BlogSectionA />
                    <Footer />
                    <SearchModal />
                    <OffcanvasMenu />
                </div>
            </div>
        </div>
    );
};

export default BlogA;